module.exports = __webpack_public_path__ + "media/images/navbar/donate_warning/Light-49cb1538c76658b712eac12ad61e6054.png";